import React from "react";
import styled from "styled-components";

interface ServiceCardProps {
  image: string;
  title: string;
  paragraph: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  image,
  title,
  paragraph,
}) => {
  return (
    <ServiceCardStyled>
      <div className="card-icon">
        <img src={image} alt={title} />
      </div>
      <h4>{title}</h4>
      <p>{paragraph}</p>
    </ServiceCardStyled>
  );
};

const ServiceCardStyled = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 2rem 1.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--primary-color),
      var(--primary-color-light)
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    border-color: var(--card-hover-border);
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);

    &::before {
      opacity: 1;
    }
  }

  .card-icon {
    width: 3rem;
    height: 3rem;
    margin-bottom: 1.25rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      filter: brightness(0) saturate(100%) invert(42%) sepia(93%)
        saturate(1352%) hue-rotate(226deg) brightness(98%) contrast(91%);
    }
  }

  h4 {
    font-size: 1.15rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    position: relative;
    padding-bottom: 0.75rem;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 2.5rem;
      height: 2px;
      background: linear-gradient(90deg, var(--primary-color), transparent);
      border-radius: 10px;
    }
  }

  p {
    font-size: 0.875rem;
    line-height: 1.7;
    color: var(--font-light-color);
  }
`;

export default ServiceCard;
